const global = window.wrike;
const COOKIE_PREFIX = 'screenshot-';
const COOKIE_OPTIONS = {
    path: '/',
    expires: global.expireYear()
};
const COOKIE_SESSION_OPTIONS = {
    path: '/'
};
const COOKIE_SUCCESS_FIELD = '_success';

export default class ScreenshotActions {
    get onSuccess() {
        return this._onSuccess;
    }
    set onSuccess(value) {
        this._onSuccess = value;
    }
    get onAdd() {
        return this._onAdd;
    }
    set onAdd(value) {
        this._onAdd = value;
    }
    get onRemove() {
        return this._onRemove;
    }
    set onRemove(value) {
        this._onRemove = value;
    }
    get unsubscribe() {
        return this._unsubscribe;
    }
    set unsubscribe(value) {
        this._unsubscribe = value;
    }
    get screenshot() {
        return this._screenshot;
    }
    set screenshot(value) {
        this._screenshot = value;
    }
    get events() {
        return this._events;
    }
    set events(value) {
        this._events = value;
    }
    get cookieName() {
        return this._cookieName;
    }
    set cookieName(value) {
        this._cookieName = value;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }

    /**
     * @param {string} screenshot - Screenshot ID.
     * @param {string} events - Window events.
     * @param {string} type - Type.
     * @param {function} onAdd - Callback on add handler.
     * @param {function} onRemove - Callback on remove handler.
     * @param {function} onSuccess - Callback on success.
     * @return {boolean} - If action has been initialized.
     * */
    constructor(screenshot, events, type, onAdd, onRemove, onSuccess) {
        this._screenshot = screenshot;
        this._events = events;
        this._type = type;

        this._onAdd = onAdd;
        this._onRemove = onRemove;
        this._onSuccess = onSuccess;

        this._details = null;

        this._cookieSetup = false;
        this._cookieName = '';

        return this.init();
    }

    /**
     * @return {boolean} - If action has been initialized.
     * */
    init() {
        if (this.noSuccessCookies) {
            this.setEventHandler();
            return true;
        }
        return false;
    }

    setEventHandler() {
        let handler;

        handler = (windowEvent) =>
            this.handle(windowEvent.detail, () => {
                this.events.forEach((event) => this.onRemove(this.screenshot, event, handler, this.type));
            });

        this.events.forEach((event) => this.onAdd(this.screenshot, event, handler, this.type));
    }

    /**
     * @param {object} details - Window event details.
     * @param {function} onSet - Callback on set handler.
     * @return {void}
     * */
    handle(details, onSet) {
        this.details = details;

        this.cookieName = COOKIE_PREFIX + this.screenshot;

        if (!this._cookieSetup) {
            this.setupCookiesStore();
        }

        if (this.noSuccessCookies() && this.validate()) {
            this.execute();
            this.writeCookie();
            onSet();
        }
    }

    setupCookiesStore() {
        let cookies = this.readCookie();

        if (!(COOKIE_SUCCESS_FIELD in cookies)) {
            cookies[COOKIE_SUCCESS_FIELD] = 0;
        }

        WG.utils.setCookie(this.cookieName, JSON.stringify(cookies), COOKIE_SESSION_OPTIONS);
        this._cookieSetup = true;
    }

    /**
     * Check if no success cookie.
     * @return {boolean} - True if no cookie.
     * */
    noSuccessCookies() {
        let cookies = this.readCookie();

        return !cookies[COOKIE_SUCCESS_FIELD];
    }

    /**
     * Read cookie store.
     * @return {array} - Cookies array.
     * */
    readCookie() {
        const cookie = WG.utils.getCookie(this.cookieName);
        let cookies = {};

        if (typeof cookie === 'undefined') {
            WG.utils.setCookie(this.cookieName, JSON.stringify([]), COOKIE_SESSION_OPTIONS);
        } else {
            cookies = JSON.parse(cookie);
        }

        return cookies;
    }

    /**
     * Write cookie flag for current screenshot.
     * @param {string} field - Screenshot attribute name.
     * @param {boolean} permanent - Expires in session or for year.
     * @return {void}
     * */
    writeCookie(field = '', permanent = false) {
        let cookies = this.readCookie();
        const fieldName = field || this.type;
        const options = permanent ? COOKIE_OPTIONS : COOKIE_SESSION_OPTIONS;

        cookies[fieldName] = 1;
        WG.utils.setCookie(this.cookieName, JSON.stringify(cookies), options);
    }

    stopTracking() {
        this.writeCookie();
        this.writeCookie(COOKIE_SUCCESS_FIELD, true);
        this.onSuccess(this.screenshot, this.type);
    }

    /**
     * Implement in child class.
     * @return {boolean} - Is ready for execute action?
     * */
    validate() {}

    /**
     * Implement in child class.
     * What to do.
     * @return {void}
     * */
    execute() {}
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/screenshot-actions.js